/**
 * Customers list tags (CWS-1579 G6): the API sends the ordered labels in `tags`
 * ("Family", "Membership"); this keeps the ones the list knows and picks each one's colour.
 */

export type CustomerTagKind = 'family' | 'membership';

export interface CustomerTagView {
  label: string;
  kind: CustomerTagKind;
}

const KNOWN_TAGS: Record<string, CustomerTagKind> = {
  Family: 'family',
  Membership: 'membership',
};

/** The tags to show for a list row; anything else in `tags` is ignored. */
export function customerTagsOf(row: { tags?: unknown } | null | undefined): CustomerTagView[] {
  if (!Array.isArray(row?.tags)) {
    return [];
  }
  return row.tags
    .filter((label): label is string => typeof label === 'string' && label in KNOWN_TAGS)
    .map(label => ({ label, kind: KNOWN_TAGS[label] }));
}
